module.exports = __webpack_public_path__ + "img/1519712304.68a9cdd4.jpg";